import { t as toPropertyKey } from './toPropertyKey-9LHu8Ao5.js';

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}

export { _defineProperty as _ };
//# sourceMappingURL=defineProperty-DmV7cVMj.js.map
